import {Component, OnInit} from '@angular/core';
import {InputBase} from '../input-base';

@Component({
  selector: 'cmp-input-check',
  template: `<span [class]="onClass" (click)="onChange()">
  <label class="m-1">{{_label}}</label>
  <span>
    <i [class.fa-square-o]="!model"
       [class.fa-check-square-o]="model"
       [class.cursor-not-allowed]="isDisabled"
       [class.cursor-pointer]="!isDisabled"
       class="fa  "></i>
  </span>
</span>
`,
  styles: [``]
})
export class InputCheckComponent extends InputBase implements OnInit {

  constructor() {
    super();
  }

  ngOnInit() {
  }

  onChange() {
    if (!this.isDisabled) {
      this.model = !this.model;
      if (this.control) {
        this.control.setValue(this.model);
      }
      this.outputModel();
    }
  }
}
